<template>
  <div>
    <div class="row">
      <div class="col-12">
        <ReportFilterPopover
          class="float-right"
          headerTitle="Customer Pricing Filter"
          :showApplyButton="true"
          :showResetButton="true"
          @apply="applyPricingFilter"
          @reset="resetPricingFilter">
          <template v-slot:popover>
            <ReportFilterGroup label="Stock Filter">
              <FormInputStockCode
                v-model="editingPricingFilter.stockId"
                @updateStockInfo="editingPricingFilter.stockInfo = $event"
                placeholder="Stock filter"
                :dropdownAutoWidth="true"
                :appendToBody="true" />
            </ReportFilterGroup>

            <ReportFilterGroup label="Price Update">
              <PriceRequestSearchableSelect
                v-model="editingPricingFilter.stockPriceRequestGroupId"
                @updateRequestInfo="editingPricingFilter.stockPriceRequestInfo = $event"
                :statusFilters="[PricingRequestStatusTypes.draft, PricingRequestStatusTypes.pendingApproval, PricingRequestStatusTypes.pendingSchedule]"
                :nullSelectionEnabled="true"
              />
            </ReportFilterGroup>                
          </template>
          <template v-slot:filterDisplay>
            <div>
              <i class="far fa-inventory mr-2"></i>{{appliedPricingFilter.stockInfo ? appliedPricingFilter.stockInfo.name : 'None'}}
            </div>
            <div v-if="appliedPricingFilter.stockPriceRequestGroupId">
              <i class="far fa-money-check-edit-alt mr-2"></i>{{appliedPricingFilter.stockPriceRequestInfo ? appliedPricingFilter.stockPriceRequestInfo.sequenceNumber : 'None'}}
            </div>
          </template>
        </ReportFilterPopover>

        <ContentTitle>Customer Pricing Report</ContentTitle>
        <ContentSubTitle>Displays prices for contacts filtered by stock and price request group</ContentSubTitle>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">

        <LoadingPanel :loading="loading" :loadingError="loadingError" />
        <div v-if="!loading">
          <PivotDataTable
            :dataset="dataset"
            :columns="columns"
            :rowFields="rowFields"
            :fields="fields">
            <template v-slot:rowfield="info">
              <strong v-if="info.data.column.field[0] == 'contactName'"><LinkContact :id="info.data.row.cellData.id" :name="info.data.row.cellData.contactName" /></strong>
              <div v-if="info.data.column.field[0] == 'defaultSalesRateName'">{{info.data.row.cellData.defaultSalesRateName}}</div>
            </template>
            <template v-slot:cell="cell">
              {{formatCurrency(parseFloat(cell.data), 2, true)}}
            </template>
            <template v-slot:empty>
              No customer pricing data found. Specify a stock to show pricing data
            </template>
          </PivotDataTable>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import PivotDataTable from '@/components/table/pivotDataTable'
import FormInputStockCode from '@/modules/inventory/components/formInputStockCode'
import PriceRequestSearchableSelect from '@/modules/pricing/components/priceRequestSearchableSelect'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'

import { PriceRequestTypes, PriceRequestTypeLookup, PricingRequestStatusTypes, PricingRequestStatusTypeLookup } from '@/store/types'

export default {
  name: 'CustomerPricingReport',
  components: {
    PivotDataTable,
    FormInputStockCode,
    PriceRequestSearchableSelect,
    ReportFilterPopover,
    ReportDateRangeSelect,
    ReportFilterGroup
  },
  data() {
    return {
      dataset: [],
      columns: [
        { field: 'stockPriceGroupName', sortField: 'stockPriceGroupSortOrder' },
        { field: 'servicePriceRangeName', sortField: 'servicePriceRangeSortOrder' }
      ],
      rowFields: [
        { field: 'contactName', name: 'Contact' },
        { field: 'defaultSalesRateName', name: 'Default Sales Rate' }
      ],
      fields: [
        { field: 'priceOverride' }
      ],
      loading: false,
      loadingError: '',

      defaultPricingFilter: {    
        stockId: null,
        stockInfo: null,
        stockPriceRequestGroupId: null,
        stockPriceRequestInfo: null
      },
      editingPricingFilter: {},
      appliedPricingFilter: {},
    }
  },
  computed: {
    
  },
  created() {
    this.PriceRequestTypes = PriceRequestTypes
    this.PricingRequestStatusTypes = PricingRequestStatusTypes
  },
  mounted() {
    this.editingPricingFilter = _.clone(this.defaultPricingFilter)
    this.appliedPricingFilter = _.clone(this.defaultPricingFilter)

    this.requestReportData()
  },
  beforeDestroy() {            
  },
  methods: {
    requestReportData() {
      this.dataset = []
      if(!this.appliedPricingFilter.stockId)
        return

      var params = {
        stockId: this.appliedPricingFilter.stockId || 0,
        stockPriceRequestGroupId: this.appliedPricingFilter.stockPriceRequestGroupId || 0
      }

      this.loading = true
      this.loadingError = ''
      this.$apiService.analyticsService.getCustomerPricingReport(params)
      .then(response => {
        this.dataset = response.data
      })    
      .catch(err => {
        console.error(err)
        this.loadingError = 'Error loading data'
      })
      .finally(() => {
        this.loading = false
      })
    },
    applyPricingFilter() {
      this.appliedPricingFilter = _.clone(this.editingPricingFilter)

      this.requestReportData()
    },
    resetPricingFilter() {
      this.editingPricingFilter = _.clone(this.defaultPricingFilter)
      this.appliedPricingFilter = _.clone(this.defaultPricingFilter)

      this.requestReportData()
    }
  }
}
</script>
